export const sources={};export const img={src:"__VITE_ASSET__XivDCLKvo3rsiwL$eU0pkA__",w:640,h:640};export default{sources:sources,img:img};